import React from 'react';
import { motion } from 'framer-motion';
import { Lock, RefreshCw, Webhook, AlertCircle, ArrowRight } from 'lucide-react';
const concepts = [{
  icon: Lock,
  title: 'Authentication',
  points: ['Bearer token authentication', 'API keys for sandbox and production', 'Secure key rotation'],
  link: '/docs/guides/authentication'
}, {
  icon: RefreshCw,
  title: 'Idempotency & Retries',
  points: ['Idempotency keys prevent duplicates', 'Automatic retry logic', 'Safe request handling'],
  link: '/docs/guides/idempotency'
}, {
  icon: Webhook,
  title: 'Webhooks',
  points: ['Real-time event notifications', 'Signature verification', 'Configurable endpoints'],
  link: '/docs/guides/webhooks'
}, {
  icon: AlertCircle,
  title: 'Errors & Rate Limits',
  points: ['Standard HTTP status codes', 'Detailed error messages', 'Rate limit headers'],
  link: '/docs/guides/errors'
}];
export function CoreConcepts() {
  return <section className="py-20 bg-slate-50" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 sm:mb-12" data-id="element-147">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4" data-id="element-148">
            Core Concepts
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-149">
            Essential patterns for building with Obseq APIs.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-150">
          {concepts.map((concept, index) => <motion.div key={concept.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-slate-200 p-6 hover:shadow-lg transition-shadow text-center sm:text-left flex flex-col items-center sm:items-start" data-id="element-151">
              {/* Icon */}
              <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600 mb-4" data-id="element-152">
                <concept.icon className="w-6 h-6" data-id="element-153" />
              </div>

              {/* Title */}
              <h3 className="text-lg font-semibold text-slate-900 mb-3" data-id="element-154">
                {concept.title}
              </h3>

              {/* Points */}
              <ul className="space-y-2 mb-4 text-left" data-id="element-155">
                {concept.points.map((point, i) => <li key={i} className="text-sm text-slate-600 flex items-start gap-2" data-id="element-156">
                    <span className="w-1 h-1 rounded-full bg-blue-600 mt-1.5 flex-shrink-0" data-id="element-157" />
                    {point}
                  </li>)}
              </ul>

              {/* Link */}
              <a href={`#${concept.link}`} className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700" data-id="element-158">
                Learn more
                <ArrowRight className="w-3 h-3" data-id="element-159" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}